import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { MessageSquare, ShieldCheck, Clock } from "lucide-react";

const eur = (n) => `€${Number(n || 0).toFixed(2).replace(".", ",")}`;
const val = (action, v) => {
  if (action === "UPDATE_PRICE") return eur(v);
  if (action === "SET_AVAILABILITY") return v === "AVAILABLE" ? "Disponibile" : "Non disponibile";
  return v ? String(v).slice(0, 60) : "—";
};

export default function WhatsappMenuAdmin() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/whatsapp/menu-admin/status").then(({ data }) => setData(data)).catch(() => {}); }, []);

  return (
    <div data-testid="wa-menu-admin-page">
      <PageHeader title="WhatsApp · Menu Admin" subtitle="Modifica prezzi, disponibilità, descrizioni e foto dei piatti via WhatsApp" testid="wa-menu-admin-header" />
      {!data ? <p className="text-sm text-muted-foreground">Caricamento…</p> : (
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Card className="p-4 rounded-xl flex items-center gap-3" data-testid="wa-ma-state">
              <ShieldCheck className={`w-6 h-6 ${data.enabled ? "text-emerald-600" : "text-muted-foreground"}`} />
              <div><p className="text-xs text-muted-foreground">Stato modulo</p><p className="font-bold">{data.enabled ? "ATTIVO" : "DISATTIVO"}</p></div>
            </Card>
            <Card className="p-4 rounded-xl flex items-center gap-3">
              <MessageSquare className="w-6 h-6 text-primary" />
              <div><p className="text-xs text-muted-foreground">Modalità</p><p className="font-bold">{data.dry_run ? "TEST (dry-run)" : "LIVE"}</p></div>
            </Card>
            <Card className="p-4 rounded-xl">
              <p className="text-xs text-muted-foreground mb-1">Numeri autorizzati</p>
              {data.numbers_masked.length ? data.numbers_masked.map((n) => <Badge key={n} variant="secondary" className="mr-1 mb-1">{n}</Badge>) : <p className="text-sm">Nessuno configurato</p>}
            </Card>
          </div>

          <Card className="p-5 rounded-xl" data-testid="wa-ma-pending">
            <h3 className="font-semibold mb-3 flex items-center gap-2"><Clock className="w-4 h-4" /> Modifiche in attesa</h3>
            {data.pending.length === 0 ? <p className="text-sm text-muted-foreground">Nessuna modifica in attesa.</p> : (
              <div className="space-y-2">
                {data.pending.map((p, i) => (
                  <div key={i} className="flex items-center justify-between text-sm border rounded-lg px-3 py-2">
                    <span><strong>{p.product_name}</strong> · {p.action}</span>
                    <span className="text-muted-foreground">{val(p.action, p.old_value)} → {val(p.action, p.new_value)}</span>
                  </div>
                ))}
              </div>
            )}
          </Card>

          <Card className="p-5 rounded-xl" data-testid="wa-ma-audit">
            <h3 className="font-semibold mb-3">Ultime modifiche (audit)</h3>
            {data.audit.length === 0 ? <p className="text-sm text-muted-foreground">Nessuna modifica registrata.</p> : (
              <div className="space-y-2">
                {data.audit.map((a, i) => (
                  <div key={i} className="flex items-center justify-between text-sm border-b pb-2">
                    <span><strong>{a.product_name}</strong> · {a.action} <span className="text-muted-foreground">({a.admin})</span></span>
                    <span className="flex items-center gap-2">
                      <span className="text-muted-foreground">{val(a.action, a.old_value)} → {val(a.action, a.new_value)}</span>
                      <Badge variant={a.status === "CONFIRMED" ? "default" : "secondary"}>{a.status}</Badge>
                    </span>
                  </div>
                ))}
              </div>
            )}
          </Card>
        </div>
      )}
    </div>
  );
}
